module.exports = __webpack_public_path__ + "static/media/coinLogo.fd0537b8.png";